if (!customElements.get('error-popup')) {
  class ErrorPopup extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        closeHandler: '.js-close-error-popup',
        errorPopup: '.error-popup',

        errorPopupActiveClass: 'error-popup--active',
      }

      this.closeHandler = this.querySelector(this.selectors.closeHandler);

      this.closeHandler.addEventListener('click', this.closePopUp.bind(this));
    }

    closePopUp() {
      this.classList.remove(this.selectors.errorPopupActiveClass);
    }
  }

  customElements.define('error-popup', ErrorPopup);
}
